import { AxiosResponse } from 'axios';
import {
  LoginRequestType,
  LoginResponseType,
  GoogleLoginRequestType,
} from './types';
import * as api from '../api';

export const login = (
  payload: LoginRequestType,
): Promise<AxiosResponse<LoginResponseType>> =>
  api.post('/auth/login', payload);

export const loginWithGoogle = (
  payload: GoogleLoginRequestType,
): Promise<AxiosResponse<LoginResponseType>> =>
  api.post('/auth/login/google', payload);
